import {
  type Vendor,
  type VendorIntegration,
  VendorIntegrationSchema,
  VendorSchema,
} from '../data/vendor';
import { createMultipleHandler, createSingleHandler } from '../helpers/fetch-wrapper';
import { storesBaseUrl as baseUrl, StoreScopedService } from './base';

export class VendorService extends StoreScopedService {
  getVendorsByStore(storeId: string): Promise<Vendor[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/vendors`)
      .then(createMultipleHandler(VendorSchema))
      .then((vendors: Vendor[]) => {
        return vendors.sort((v1, v2) => {
          if (v1.disabled === v2.disabled) {
            return v1.name.localeCompare(v2.name);
          }

          return v1.disabled ? 1 : -1;
        });
      });
  }

  updateVendor(storeId: string, vendor: Vendor): Promise<Vendor> {
    return this.fetchWrapper
      .put(`${baseUrl}/${storeId}/vendors/${vendor.vendor_id}`, vendor)
      .then(createSingleHandler(VendorSchema));
  }

  reEnableRepresentative(storeId: string, vendorId: string, email: string): Promise<Vendor> {
    return this.fetchWrapper
      .post(`${baseUrl}/${storeId}/vendors/${vendorId}/representatives/reenable`, { email })
      .then(createSingleHandler(VendorSchema));
  }

  getVendorIntegrations(storeId: string): Promise<VendorIntegration[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/vendor-integrations`)
      .then(createMultipleHandler(VendorIntegrationSchema));
  }
}
